export const CONTAINER_BREAKPOINT_VALUE = {
    S: `485`,
    M: `620`,
    L: `756`,
    XL: `1024`,
    XXL: `1280`,
    XXXL: `1568`,
};

export const CONTAINER_BREAKPOINT_NUMBER = {
    S: Number(CONTAINER_BREAKPOINT_VALUE.S),
    M: Number(CONTAINER_BREAKPOINT_VALUE.M),
    L: Number(CONTAINER_BREAKPOINT_VALUE.L),
    XL: Number(CONTAINER_BREAKPOINT_VALUE.XL),
    XXL: Number(CONTAINER_BREAKPOINT_VALUE.XXL),
    XXXL: Number(CONTAINER_BREAKPOINT_VALUE.XXXL),
};

export const CONTAINER_BREAKPOINT = {
    S: `${CONTAINER_BREAKPOINT_VALUE.S}px`,
    M: `${CONTAINER_BREAKPOINT_VALUE.M}px`,
    L: `${CONTAINER_BREAKPOINT_VALUE.L}px`,
    XL: `${CONTAINER_BREAKPOINT_VALUE.XL}px`,
};

export const CQ = {
    DOWN_S: `@container (max-width: ${CONTAINER_BREAKPOINT_NUMBER.S}px)`,
    DOWN_M: `@container (max-width: ${CONTAINER_BREAKPOINT_NUMBER.M}px)`,
    DOWN_L: `@container (max-width: ${CONTAINER_BREAKPOINT_NUMBER.L}px)`,
    DOWN_XL: `@container (max-width: ${CONTAINER_BREAKPOINT_NUMBER.XL}px)`,
};
